<template>
    <div :class="{ 'p-2': !isResume }" class="tab-logs__container">
        <div class="row mx-0 h-100" :class="{ 'border': !isResume }">
            <div class="col-12 px-0 bg-lightest d-flex flex-column">
                <div :class="{ 'border': isResume }" class="tab-logs__container--root">
                    <div class="tab-logs__table-container">
                        <table class="tab-logs__table-container--table-details mt-2">
                            <colgroup>
                                <col style="width:30%">
                                <col style="width:70%">
                            </colgroup>
                            <tbody>
                                <tr v-for="(audit, i) in paginatedAudits" :key="auditKey(audit, i)"
                                    class="tab-logs__table-container--table-row"
                                    :class="{ expanded: isOpen(i, audit) }">
                                    <!-- 30% -->
                                    <td class="tabs-logs__table-user-col">
                                        <div class="tabs-logs__table-user-col--wrap">
                                            <img v-if="audit.userLogo" class="tabs-logs__table-user-col--avatar"
                                                :src="audit.userLogo">
                                            <div v-else class="tabs-logs__table-user-col--avatar">{{ audit.username[0] }}</div>

                                            <div>
                                                <div class="tabs-logs__table-user-col--name">{{ audit.username || '—' }}
                                                </div>
                                                <div class="tabs-logs__table-user-col--time">{{ audit.timestamp }}</div>
                                            </div>
                                        </div>
                                    </td>

                                    <!-- 70% -->
                                    <td class="tabs-logs__table-entry-col">
                                        <div class="entry">
                                            <div v-if="audit.shouldShowMore && audit.entries && audit.entries.length"
                                                class="tabs-logs__table-entry-col--entry-box"
                                                :class="{ open: isOpen(i, audit) }">

                                                <div class="tabs-logs__table-entry-col--entry-box-header">
                                                    <span class="tabs-logs__title link-color"
                                                        v-html="buildTitleHtml(audit)" @click="onAuditClick">
                                                    </span>

                                                    <a href="#" class="see-more" @click.prevent="toggleRow(i, audit)">
                                                        {{ isOpen(i, audit) ? 'close' : 'see more' }}
                                                    </a>
                                                </div>

                                                <div class="tabs-logs__table-entry-box--content"
                                                    v-show="isOpen(i, audit)">
                                                    <div class="tabs-logs__table-entry-box--note darkest">
                                                        <div v-for="(e, idx) in audit.entries" :key="idx"
                                                            class="note-line">

                                                            <span v-if="e.property" class="note-prop">{{ e.property ||
                                                                '' }}:</span>
                                                            <span class="note-old-val">{{ displayValue(e.oldValue)
                                                            }}</span>
                                                            <span class="note-arrow"> → </span>
                                                            <span class="note-new-val">{{ displayValue(e.newValue)
                                                            }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Caso NÃO tenha "see more": mantém só o título, como antes -->
                                            <div v-else class="tabs-logs__table-entry-col--entry-title">
                                                <span class="tabs-logs__title tabs-logs__title--no-see-more link-color"
                                                    v-html="buildTitleHtml(audit)" @click="onAuditClick">
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    
                    <div class="tabs-log__pagination" v-if="totalPages > 1 && !isResume">
                        <button class="tabs-log__pagination-btn-page" :disabled="page === 1"
                            @click="prevPage">Previous</button>
                        <span class="tabs-log__pagination-page-info">Page {{ page }} of {{ totalPages }}</span>
                        <button class="tabs-log__pagination-btn-page" :disabled="page === totalPages"
                            @click="nextPage">Next</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    props: {
        reservation: {
            type: Object
        },
        disabled: {
            type: Boolean,
            default: false
        },
        isResume: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            audits: [],
            page: 1,
            openState: {},
            maxLogsInResume: 5,
            maxLogsPerPage: 6
        }
    },
    watch: {
        reservation: {
            handler() {
                this.page = 1;
                this.openState = {};
            },
            deep: false
        },
        totalPages(n) {
            if (this.page > n) this.page = n;
            if (this.page < 1) this.page = 1;
        }
    },
    created() {
    },
    computed: {
        ...mapGetters([]),

        auditsResolved() {
            const reservation = this.reservation || {};
            return Array.isArray(reservation.audits) ? reservation.audits : [];
        },

        totalPages() {
            return Math.max(1, Math.ceil(this.auditsResolved.length / this.maxLogsPerPage));
        },

        paginatedAudits() {
            if (this.isResume) {
                return this.auditsResolved.slice(0, this.maxLogsInResume);
            }

            const size = this.maxLogsPerPage;
            const p = Math.min(Math.max(this.page, 1), this.totalPages);
            const start = (p - 1) * size;

            return this.auditsResolved.slice(start, start + size);
        },
    },
    methods: {
        ...mapActions([
            'closeModal',
            'openReservationById'
        ]),
        onAuditClick(e) {
            const a = e.target.closest && e.target.closest('a.audit-link');

            if (!a) return;
            e.preventDefault();

            const reservationId = a.dataset.resId;
            this.clickReservation(reservationId);
        },
        clickReservation(reservationId) {
            this.closeModal();
            this.openReservationById(reservationId);

            return false;
        },
        auditKey(audit, idx) {
            const t = audit && audit.timestamp ? String(audit.timestamp) : '';
            const u = audit && audit.username ? String(audit.username) : '';
            const m = audit && audit.message ? String(audit.message) : '';

            return `${this.page}-${idx}-${t}-${u}-${m}`.replace(/\s+/g, '');
        },
        isOpen(i, audit) {
            return !!this.openState[this.auditKey(audit, i)]
        },
        toggleRow(i, audit) {
            const k = this.auditKey(audit, i)
            this.$set(this.openState, k, !this.openState[k])
        },
        prevPage() {
            if (this.page > 1) this.page--
        },
        nextPage() {
            if (this.page < this.totalPages) this.page++
        },
        displayValue(v) {
            return (v === null || v === undefined || String(v) === '') ? ' ' : String(v);
        },
        buildTitleHtml(audit) {
            const message = audit && audit.message ? String(audit.message) : '';
            if (!message) return '';

            const tokenRE = /\{\{(.*?)\}\}/;
            const match = message.match(tokenRE);
            if (!match) return this.escapeHtml(message);

            const [fullMatch, tokenTextRaw] = match;
            const before = message.slice(0, match.index);
            const after = message.slice(match.index + fullMatch.length);

            const tokenText = this.escapeHtml(String(tokenTextRaw));
            const beforeHasHash = before.endsWith('#');
            const displayTokenText = beforeHasHash ? `#${tokenText}` : tokenText;

            const tokenHtml = audit.shouldBeReferenced
                ? `<a href="#" class="audit-link" data-res-id="${tokenText}">${displayTokenText}</a>`
                : `<span>${displayTokenText}</span>`;

            const colorClass = audit.shouldBeColored
                ? ({
                    green: 'tabs-logs--text-green',
                    red: 'tabs-logs--text-red'
                }[String(audit.colorType).toLowerCase()])
                : '';

            const coloredTokenHtml = colorClass
                ? `<span class="${colorClass}">${tokenHtml}</span>`
                : tokenHtml;

            return `${this.escapeHtml(beforeHasHash ? before.slice(0, -1) : before)}${coloredTokenHtml}${this.escapeHtml(after)}`;
        },
        escapeHtml(s = '') {
            return String(s)
                .replace(/&/g, '&amp;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
        }
    },
    components: {}
}
</script>

<style lang="scss" scoped>
.tab-logs__container {
    height: 100%;

    &--root {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
    }
}

.tab-logs__table-container {
    flex: 1 1 auto;

    &--table-details {
        width: 100%;
        border-collapse: collapse;
    }

    &--table-row {
        height: 64px;

        &:not(:first-child) td {
            border-top: 1px solid #e6e8eb;
        }
    }
}

.tabs-logs__table-user-col {
    vertical-align: top;
    padding: 10px 12px;

    &--wrap {
        display: flex;
        align-items: center;
    }

    &--avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: #dcdfe4;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        color: #555;
        margin-right: 8px;
    }

    &--name {
        font-weight: 600;
        color: #222;
        line-height: 1.2;
    }

    &--time {
        font-size: 12px;
        color: #7a869a;
    }
}

.tabs-logs__table-entry-col {
    vertical-align: middle;
    padding: 10px 12px;

    &--entry-title {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
        color: #222;
    }

    &--entry-box {
        background: #f6f7f9;
        border: 1px solid #e6e8eb;
        border-radius: 4px;
        padding: 10px 12px;

        &-header {
            display: flex;
            align-items: center;
            gap: 8px;
            flex-wrap: wrap;
            color: #222;

            .see-more {
                margin-left: auto;
                font-size: 12px;
                text-decoration: underline;
                color: #4768b5;
                font-weight: normal;

                &:hover {
                    color: #2f4d91;
                }
            }
        }
    }
}


.tabs-logs__title {
    margin-right: 6px;
    font-weight: 600;
}

.tabs-logs__title--no-see-more {
    font-weight: normal;
}

.tabs-logs__table-entry-box {
    &--content {
        margin-top: 8px;
    }

    &--note {
        .note-line {
            padding: 3px 0;
        }

        .note-prop {
            font-weight: 600;
            margin-right: 6px;
        }

        .note-old-val {
            opacity: 0.85;
        }

        .note-arrow {
            padding: 0 6px;
            opacity: 0.6;
        }

        .note-new-val {
            font-weight: 600;
        }
    }
}

/* paginação */
.tabs-log__pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    padding: 10px 12px;
    border-top: 1px solid #e6e8eb;

    &-btn-page {
        border: 1px solid #e6e8eb;
        background: #fff;
        border-radius: 4px;
        padding: 4px 10px;
        cursor: pointer;

        &:disabled {
            opacity: .5;
            cursor: not-allowed;
        }
    }

    &-page-info {
        font-size: 12px;
        color: #7a869a;
    }
}
</style>

<style lang="scss">
.tabs-logs--text-green,
.tabs-logs--text-green a {
    color: #0a8f3f;
}

.tabs-logs--text-red,
.tabs-logs--text-red a {
    color: #c0392b;
}

.tabs-logs--text-muted,
.tabs-logs--text-muted a {
    color: #7a869a;
}

.tabs-logs__table-entry-col--entry-box-header span.link-color a {
    color: #007bff;
    text-decoration: none;
    background-color: transparent;

    &:hover {
        color: #007bff;
        text-decoration: none;
        background-color: transparent;
    }
}
.link-color a.audit-link,
.tabs-logs__title.link-color a.audit-link {
    color: #007bff;
    text-decoration: underline;
    background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// TabLogs.vue?3a4a0595